import React from "react";
import styles from "./secondaryButton.module.scss";

type Props = {
  label: string;
  disabled: boolean;
  type?: "submit" | "reset" | "button" | undefined;
} & React.HTMLAttributes<HTMLButtonElement>;

export default function SecondaryButton({
  label,
  disabled,
  type,
  ...restProps
}: Props) {
  return (
    <button
      className={styles.secondaryButton}
      disabled={disabled}
      type={type}
      {...restProps}
    >
      {label}
    </button>
  );
}
